import { Component, Input, OnInit, ViewEncapsulation, Injector } from '@angular/core';
import { TagTextData } from '../tag-text/tag-text.component';
import {ButtonOptions} from "../eva-button/eva-button.component";
import { AbstractComponent } from '../abstract.component';
import { Module } from 'projects/common/model/ModuleModel';


export interface ParagraphsData {
    paragraphs_list: ParagraphItem[];
    show_container?: boolean;

}

export interface ParagraphItem {
    title: TagTextData;
    text: string;
    button_options: ButtonOptions;
    paragraphs_list: ParagraphItem[];

    //deprecated tom
    link: string;
    link_title: string;
}

@Component({
    selector: 'paragraphs',
    template: `
        <div [ngClass]="{'eva-3-card -eva-3-shadow-line paragraph-container': module.data.show_container}">
            <paragraphs-recursive [data]="module.data" [uniqueId]="module.unique_id" [moduleId]="module.id" [moduleIndex]="module.row_number"></paragraphs-recursive>
        </div>
    `,
    styleUrls: ['./paragraphs.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ParagraphsComponent extends AbstractComponent {
    private static MODULE_ID: string = "ParagraphsModule";

    @Input() override module: Module<ParagraphsData>;

    constructor(injector: Injector) {
        super(injector);
    }

    getModuleId() {
        return ParagraphsComponent.MODULE_ID;
    }
}
